"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStreamSLI = void 0;
var _useCommonPageActionsApi = require("../../client/react/useCommonPageActionsApi");
var _useCustomPageActionApi = require("../../client/useCustomPageActionApi");
var useStreamSLI = exports.useStreamSLI = function useStreamSLI() {
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    streamStartedWorkflow = _useCommonPageActions.streamStartedWorkflow,
    streamStoppedWorkflow = _useCommonPageActions.streamStoppedWorkflow;
  var _useCustomPageActions = (0, _useCustomPageActionApi.useCustomPageActionsApi)(),
    startStreamStartLifecycle = _useCustomPageActions.startStreamStartLifecycle,
    endStreamStartLifecycle = _useCustomPageActions.endStreamStartLifecycle,
    startStreamStopLifecycle = _useCustomPageActions.startStreamStopLifecycle,
    endStreamStopLifecycle = _useCustomPageActions.endStreamStopLifecycle;

  /**
   * This function is used to start the Start Stream SLI when the Start or Start all button is clicked.
   * @param {string} streamId - The id of stream that was started
   * @returns {void}
   */
  var startStreamStartSLI = function startStreamStartSLI(payload) {
    startStreamStartLifecycle(payload);
    streamStartedWorkflow(payload);
  };

  /**
   * This function is used to end the Start Stream SLI when the Stream started succeeded or failed.
   * @param {string} streamId - The id of stream that was started
   * @returns {void}
   */
  var startStreamEndSLI = function startStreamEndSLI(payload) {
    endStreamStartLifecycle(payload);
  };

  /**
   * This function is used to start the Stop Stream SLI when the Stop or Stop all button is clicked.
   * @param {string} streamId - The id of Stream that was started
   * @returns {void}
   */
  var stopStreamStartSLI = function stopStreamStartSLI(payload) {
    startStreamStopLifecycle(payload);
    streamStoppedWorkflow(payload);
  };

  /**
   * This function is used to end the Stop Stream SLI when the Stream stopped succeeded or failed.
   * @param {string} streamId - The id of Stream that was started
   * @returns {void}
   */
  var stopStreamEndSLI = function stopStreamEndSLI(payload) {
    endStreamStopLifecycle(payload);
  };
  return {
    startStreamStartSLI: startStreamStartSLI,
    startStreamEndSLI: startStreamEndSLI,
    stopStreamStartSLI: stopStreamStartSLI,
    stopStreamEndSLI: stopStreamEndSLI
  };
};